import { SolicitacaoService } from './../../../core/apis/orchestrador/api/solicitacao.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Navigation, Router } from '@angular/router';
import { OrdemService } from 'src/app/core/apis/orchestrador/api/ordem.service';
import { OficiosService } from 'src/app/core/apis/orchestrador/api/oficios.service';
import { Globals } from 'src/app/core/helpers/globals';
import { Ordem } from "../../../core/apis/orchestrador/model/ordem";
import { MatDividerModule } from '@angular/material/divider';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { HttpResponse } from '@angular/common/http';
import { GenerateUrlCartaResponse } from 'src/app/core/apis/orchestrador/model/generateUrlCartaResponse';

@Component({
  selector: 'app-dados-ordem',
  templateUrl: './dados-ordem.component.html',
  styleUrls: ['./dados-ordem.component.css'],
  standalone: true,
  providers: [provideNgxMask()],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatCardModule,
    MatButtonModule,
    MatDividerModule,
    NgxMaskPipe
]
})


export class DadosOrdemComponent implements OnInit {

  ordem!: Ordem;

  tokenIam!: string;
  nomeArquivo!: string;

  constructor(
    private oficiosService: OficiosService,
    private solicitacaoService: SolicitacaoService,
    private ordemService: OrdemService,
    private globals: Globals,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const navigation = this.router.lastSuccessfulNavigation;

    if (navigation) {
      this.getDataFromNavigation(navigation);
    }
  }

  private getDataFromNavigation(navigation: Navigation) {
    const state = navigation.extras.state;

    if (state) {
      this.ordem = state['data'];
      this.tokenIam = state['token'];
      this.buscarOrdem(this.ordem);
    } else {
      this.globals.showSnackBar("Desculpe! Algo de errado aconteceu.");
      this.voltar();
    }
  }

  private buscarOrdem(ordem: Ordem) {
    this.globals.addToLoading('dados-ordem');
    this.ordemService.detalharOrdem(ordem, this.tokenIam).subscribe({
      next: ordem => {
        this.ordem = ordem.body;
        if (this.isBaixaDoSJ1()) {
          this.ordem.acao = {
            vlrAcao: this.extractVlrAcaoFromDescricao()
          }
        }
        this.globals.subtractFromLoading();
        if (this.ordem.sistemaOrigem === 'SJ1') {
          if (this.hasAnexo()) this.buscarDadosAnexo();
        } else if (this.ordem.sistemaOrigem === 'SJ') {
          if (this.hasAnexo()) this.nomeArquivo =  this.ordem.nomeArquivoEnvio;
        }
      },
      error: error => {
        this.globals.subtractFromLoading();
        console.log('Aplicação gerou um erro. ', error);

        let finalMessage = error?.error?.Erros?.[0]?.message;

        switch(true) {
          case (error.status == 400):
            this.globals.showSnackBar(finalMessage || "Requisição inválida, verifique os dados e tente novamente por favor.");
            break;

          case (error.status == 403):
            this.globals.showSnackBar(finalMessage || "Você não possui permissão para executar esta ação.");
            break;

          case (error.status == 404):
            this.globals.showSnackBar(finalMessage || "O registro não foi encontrado.");
            break;

          case (error.status == 422):
            this.globals.showSnackBar(finalMessage || "Sua requisição contem campos inválidos, por favor verifique e tente novamente.");
            break;

          case (error.status == 429):
            this.globals.showSnackBar(finalMessage || "Consulta de detalhes de ordem: limite de requisições atingido, por favor aguarde um minuto e tente novamente.");
            break;

          default:
            this.globals.showSnackBar(error?.error?.Erros?.[0]?.message || "Houve um problema ao buscar os detalhes da ordem, por favor, tente novamente mais tarde.");
            break;
        }

        // this.globals.showSnackBar("Desculpe! Algo de errado aconteceu.");
        this.voltar();
      }
    });
  }

  private buscarDadosAnexo() {
    this.globals.addToLoading('detalhar-ordem');
    this.oficiosService.getDetalheArquivo(this.ordem.arquivoOficioEnvio, this.tokenIam).subscribe(
      data => {
        this.nomeArquivo = data.body.fileName;
        this.globals.subtractFromLoading();
      },
      (error) => {
        let finalMessage = error?.error?.Erros?.[0]?.message;

        switch(true) {
          case (error.status == 400):
            this.globals.showSnackBar(finalMessage || "Requisição inválida, verifique os dados e tente novamente por favor.");
            break;

          case (error.status == 403):
            this.globals.showSnackBar(finalMessage || "Você não possui permissão para executar esta ação.");
            break;

          case (error.status == 404):
            this.globals.showSnackBar(finalMessage || "O arquivo não foi encontrado.");
            break;

          case (error.status == 422):
            this.globals.showSnackBar(finalMessage || "Sua requisição contem campos inválidos, por favor verifique e tente novamente.");
            break;

          case (error.status == 429):
            this.globals.showSnackBar(finalMessage || "Busca de arquivo: limite de requisições atingido, por favor aguarde um minuto e tente novamente.");
            break;

          default:
            this.globals.showSnackBar(error?.error?.Erros?.[0]?.message || "Houve um problema ao buscar o arquivo, por favor, tente novamente mais tarde.");
            break;
        }

        // this.globals.showSnackBar("Arquivo anexado indisponível, por favor, tente novamente mais tarde.");
      }
    );
  }

  public getNroSolicitacao(): string {
    return `${this.ordem.nroOrdem}/${this.ordem.anoOrdem}`;
  }

  public getDiasSla(): string {
    const diasSla = this.ordem.nroSla / 24
    return `${diasSla} ${diasSla === 1 ? "dia": "dias"}`;
  }

  public hasDescricao(): boolean {
    return this.ordem.decricaoOrdem != null;
  }

  public hasAnexo(): boolean {
    return this.ordem.arquivoOficioEnvio !== null && this.ordem.arquivoOficioEnvio !== '';
  }

  public hasVlrAcao(): boolean {
    return this.ordem.acao && this.ordem.acao.vlrAcao !== null;
  }

  public hasMotivoCancelamento(): boolean {
    return this.ordem.status == Ordem.StatusEnum.CAN && this.ordem.motivoCancelamento != null;
  }

  public getformatedVlrAcao(): string {
    return 'R$ ' + this.ordem.acao.vlrAcao.toFixed(2).replace('.', ',');
  }

  private isBaixaDoSJ1(): boolean {
    return this.ordem.tpOrdemFormatado === 'Baixa' && this.ordem.sistemaOrigem == 'SJ1';
  }

  public isPessoaFisica(nroDocumento: string) {
    return nroDocumento.length == 11;
  }

  private extractVlrAcaoFromDescricao(): number {
    const regex = /R\$\s?(\d+.\d{2})/;
    const match = this.ordem.decricaoOrdem.match(regex);
    return match ? parseFloat(match[1]) : null;
  }

  public downloadArquivo() {
    this.globals.addToLoading('detalhar-ordem');

    if (this.ordem.sistemaOrigem === "SJ") {
      this.solicitacaoService.getArquivoUrl(this.ordem.arquivoOficioEnvio, this.tokenIam).subscribe({
            next: (result: HttpResponse<GenerateUrlCartaResponse>) => {
              this.globals.subtractFromLoading();
              window.open(result.body.fileUrl,"_blank");
            },
            error: error => {
              console.error(error);
              this.globals.subtractFromLoading();
            }
          });
    }
    else if(this.ordem.sistemaOrigem === "SJ1") {
      this.oficiosService.getDownloadArquivo(this.ordem.arquivoOficioEnvio, this.tokenIam)
      .subscribe({
        next: result => {
          const url = window.URL.createObjectURL(result.blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = result.fileName;
          a.click();
          this.globals.subtractFromLoading();
        },
        error: error => {
          console.error("Erro api: ", error);

          let finalMessage = error?.error?.Erros?.[0]?.message;

          switch(true) {
            case (error.status == 400):
              this.globals.showSnackBar(finalMessage || "Requisição inválida, verifique os dados e tente novamente por favor.");
              break;

            case (error.status == 403):
              this.globals.showSnackBar(finalMessage || "Você não possui permissão para executar esta ação.");
              break;

            case (error.status == 404):
              this.globals.showSnackBar(finalMessage || "O arquivo não foi encontrado.");
              break;

            case (error.status == 422):
              this.globals.showSnackBar(finalMessage || "Sua requisição contem campos inválidos, por favor verifique e tente novamente.");
              break;

            case (error.status == 429):
              this.globals.showSnackBar(finalMessage || "Download de arquivo: limite de requisições atingido, por favor aguarde um minuto e tente novamente.");
              break;

            default:
              this.globals.showSnackBar(error?.error?.Erros?.[0]?.message || "Houve um problema ao baixar o arquivo, por favor, tente novamente mais tarde.");
              break;
          }

          // this.globals.showSnackBar("Failed to download file.");
          this.globals.subtractFromLoading();
        }
      });
    }
  }

  public voltar () {
    this.router.navigate(["listar-ordem", this.ordem.nroProcesso]);
  }
}
